// Reaction reducer + the cache fan-out that applies it. Shared by the hub
// handler (server echo) and the message bubble's optimistic click so both
// paths land the same shape. The reducer is idempotent: the echo re-applying
// a change already patched locally is a no-op, and a failed request is undone
// by applying the inverse event.
import { queryClient } from '@/lib/queryClient';
import { TEAM_THREAD_KEY_PREFIX, teamMessagesKey } from './queryKeys';
export function applyReactionChange(message, event) {
    if (message.id !== event.messageId)
        return message;
    const target = message.reactions.find((r) => r.emoji === event.emoji);
    const userIds = new Set(target?.userIds ?? []);
    if (event.removed)
        userIds.delete(event.userId);
    else
        userIds.add(event.userId);
    if (userIds.size === 0) {
        return { ...message, reactions: message.reactions.filter((r) => r.emoji !== event.emoji) };
    }
    // Update an existing chip IN PLACE (a chip that jumps to the end of the strip
    // when someone else reacts moves under the user's cursor); only a brand-new
    // emoji appends.
    const updated = { emoji: event.emoji, userIds: [...userIds] };
    const reactions = target
        ? message.reactions.map((r) => (r.emoji === event.emoji ? updated : r))
        : [...message.reactions, updated];
    return { ...message, reactions };
}
/** Patch the conversation page AND every cached thread (root + replies): a
 * reaction on a thread reply lives only in the thread cache, and a reaction
 * on a root must show in both places. */
export function patchReactionCaches(event) {
    queryClient.setQueryData(teamMessagesKey(event.conversationId), (prev) => prev ? { ...prev, messages: prev.messages.map((m) => applyReactionChange(m, event)) } : prev);
    queryClient.setQueriesData({ queryKey: [...TEAM_THREAD_KEY_PREFIX] }, (prev) => prev
        ? {
            ...prev,
            parent: applyReactionChange(prev.parent, event),
            messages: prev.messages.map((m) => applyReactionChange(m, event)),
        }
        : prev);
}
